import React, { useState, useEffect, useContext } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch';
import TextField from "@material-ui/core/TextField";
import BeatLoader from 'react-spinners/BeatLoader';
import FormControl from '@material-ui/core/FormControl';
import LoadingOverlay from 'react-loading-overlay';
import Button from 'react-bootstrap-button-loader';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronsUp, faChevronsDown } from "@fortawesome/pro-duotone-svg-icons";
import { formatDate, isNullOrEmpty, isIOS } from '@utils';
import * as storage from '@utils/storage'
import * as pageSourceCode from '@scripts/PageSourceCode';
import i18next from 'i18next';
import styles from '@styles/approvalCentral.module.css';
import { messagesTypes } from '@utils/constants';
import { MessageContext } from '@/MessageProvider';
import { getCentralApprovalTypeDescription, approvalType } from '@scripts/CentralApprovalTypeHelper';
import { getCentralApprovalStatusDescription, centralApprovalStatus } from '@scripts/CentralApprovalStatusHelper';
import PayBankBalance from '@components/bankBalance/payBank/PayBankBalance';

const useStyles = makeStyles({
    table: {
        '& td': {
            fontSize: 16,
            '@media (max-width: 600px)': {
                fontSize: 11,
            }
        },
        '& td:first-child': {
            width: '30%',
            '@media (max-width: 600px)': {
                width: '50%'
            }
        },
        divInput: {
            display: 'table',
            marginBottom: '10px',
            width: '100%',
            '& > div.MuiInputBase-root, div.MuiFormControl-root': {
                width: '100%'
            }
        }
    },
    accordionSummary: {
        color: 'var(--color2) !important'
    },
    iconExpanded: {
        color: 'var(--color2) !important'
    }
});

const StyledFirstTableCell = withStyles((theme) => ({
    body: {
        fontSize: 14,
        width: '200px',
        '@media (max-width: 600px)': {
            width: "150px"
        },
        fontWeight: "bold"
    },
}))(TableCell);

const StyledSecondTableCell = withStyles((theme) => ({
    head: {
        color: '#000000!important',
        fontSize: 16,
        width: '75%',
        '@media (max-width: 600px)': {
            fontSize: 12,
            width: "75%"
        },
        fontWeight: 'bold'
    },
    body: {
        fontSize: 16,
        '@media (max-width: 600px)': {
            fontSize: 11,
        }
    },
}))(TableCell);

const StyledCommentTableCell = withStyles((theme) => ({
    body: {
        fontSize: 14,
        width: '200px',
        '@media (max-width: 600px)': {
            width: "150px"
        },
        fontWeight: "bold"
    },
}))(TableCell);

export default function RequestDetailLeaveDisplay(props) {

    const classes = useStyles();
    const { dispatch } = useContext(MessageContext);

    const {
        pageSource,
        data,
        dataRequest,
        saveClick,
        comment,
        setComment,
        isToReplace,
        setIsToReplace,
        isPosting,
        handleRequest,
        getIsLeaveRequest,
        getIsActionButtonShown,
        getIsDenyButtonEnabled,
        getIsApproveButtonEnabled
    } = props;

    const [isiOS] = useState(isIOS());
    const [isActive, setIsActive] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [approverComment, setApproverComment] = useState(comment);
    const [isActionButtonShown] = useState(getIsActionButtonShown(data));
    const [isDenyButtonEnabled] = useState(getIsDenyButtonEnabled(data));
    const [isApproveButtonEnabled] = useState(getIsApproveButtonEnabled(data));
    const [denyTitle] = useState(!getIsLeaveRequest(data) && data.statusCode == centralApprovalStatus.CLOSE ? i18next.t('approvalCentral:button.cancel') : i18next.t('approvalCentral:button.deny'));
    const [isToReplaceEnabled] = useState(!dataRequest.isAzur
        && !storage.getAllowConsultation()
        && data.scheduleType !== 'F'
        && data.statusCode == centralApprovalStatus.OPENED);
    const [isEditable] = useState(!dataRequest.isAzur
        && !(!storage.getIsSuperUser()
            && (data.statusCode == centralApprovalStatus.CANCELED || data.statusCode == centralApprovalStatus.CLOSE)
            && !dataRequest.isCurrentSupervisorLastEdit)
        && data.approvalType == approvalType.LEAVE);

    const actionType = {
        DENY: 'R',
        APPROVE: 'F'
    }

    const [showAdditionalInfo, setShowAdditionalInfo] = React.useState(false);

    useEffect(() => {
        resizeForm();
    }, [])

    const resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const offSet = isiOS ? 73 : 63;
            const customHeight = height - titleBar - offSet;
            const element = document.querySelector('#divDetailLeave');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }

            setIsActive(false);
        }, 100);
    }

    const handleAdditionalInfoClick = () => {
        setShowAdditionalInfo(true);
    };

    const handleHideAdditionalInfo = () => {
        setShowAdditionalInfo(false);
    };

    const onToReplace = (event) => {
        setIsToReplace(event.target.checked);
    }

    const onChangeComment = (event) => {
        setApproverComment(event.target.value);
    }

    const validForm = (action) => {

        if (action == actionType.DENY
            && storage.getIsRefusalRequestMandatoryComment()
            && !approverComment?.trim()) {
            dispatch({ type: messagesTypes.CUSTOMERROR, payload: i18next.t('approvalCentral:message.refusalComent') });
            return false;
        }

        return true;
    }

    const handleRequestClick = (event, action) => {
        if (validForm(action)) {
            setComment(approverComment);
            handleRequest(event, data, action, false);
        }
    }

    const handleSaveClick = () => {
        setComment(approverComment);
        saveClick(approverComment);
    }

    const onIsLoadedPayBankBalance = (isLoaded) => {
        setIsActive(isLoaded);
    }

    const handleAccordion = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <React.Fragment>
            <div id="divDetailLeave" className={styles.detailRequest}>
                {!showAdditionalInfo &&
                    <>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="spanning table">
                                <TableBody>
                                    <TableRow>
                                        <StyledFirstTableCell>Type</StyledFirstTableCell>
                                        <StyledSecondTableCell>{getCentralApprovalTypeDescription(data.approvalType)}</StyledSecondTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledCommentTableCell>{i18next.t("approvalCentral:form.employeeCode")}</StyledCommentTableCell>
                                        <StyledSecondTableCell>{data.employeeCode}</StyledSecondTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledCommentTableCell>{i18next.t("approvalCentral:form.employeeName")}</StyledCommentTableCell>
                                        <StyledSecondTableCell>{data.employeeFullName}</StyledSecondTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledFirstTableCell>{i18next.t("approvalCentral:form.status")}</StyledFirstTableCell>
                                        <StyledSecondTableCell>{getCentralApprovalStatusDescription(data.statusCode)}</StyledSecondTableCell>
                                    </TableRow>
                                    {storage.getIsUsePartialRequest() && <TableRow>
                                        <StyledFirstTableCell>{i18next.t("approvalCentral:form.partial")}</StyledFirstTableCell>
                                        <StyledSecondTableCell>{i18next.t(`approvalCentral:table.${dataRequest.isPartial ? "yes" : "no"}`)}</StyledSecondTableCell>
                                    </TableRow>}
                                    <TableRow>
                                        <StyledFirstTableCell>{i18next.t(`approvalCentral:${dataRequest.isPartial ? "form.request-date" : "form.startDate"}`)}</StyledFirstTableCell>
                                        <StyledSecondTableCell>{formatDate(dataRequest.startDate, 'date')}</StyledSecondTableCell>
                                    </TableRow>
                                    {!isNullOrEmpty(dataRequest.endDate) && <TableRow>
                                        <StyledFirstTableCell>{i18next.t("approvalCentral:form.endDate")}</StyledFirstTableCell>
                                        <StyledSecondTableCell>{formatDate(dataRequest.endDate, 'date')}</StyledSecondTableCell>
                                    </TableRow>}
                                    <TableRow>
                                        <StyledFirstTableCell>{i18next.t("approvalCentral:form.approved")}</StyledFirstTableCell>
                                        <StyledSecondTableCell>{i18next.t(`approvalCentral:table.${data.isApproved ? "yes" : "no"}`)}</StyledSecondTableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className={classes.divInput} style={{ textAlign: 'center' }} onClick={handleAdditionalInfoClick}>
                            <span style={{ fontSize: '12px', marginRight: '10px' }}>{i18next.t('approvalCentral:button.additionInformation')}</span>
                            <FontAwesomeIcon icon={faChevronsDown} />
                        </div>
                    </>
                }

                {showAdditionalInfo &&
                    <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="spanning table">
                            <TableBody>
                                <TableRow>
                                    <StyledFirstTableCell>Type</StyledFirstTableCell>
                                    <StyledSecondTableCell>{getCentralApprovalTypeDescription(data.approvalType)}</StyledSecondTableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledCommentTableCell>{i18next.t("approvalCentral:form.employeeCode")}</StyledCommentTableCell>
                                    <StyledSecondTableCell>{data.employeeCode}</StyledSecondTableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledCommentTableCell>{i18next.t("approvalCentral:form.employeeName")}</StyledCommentTableCell>
                                    <StyledSecondTableCell>{data.employeeFullName}</StyledSecondTableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledFirstTableCell>{i18next.t("approvalCentral:form.status")}</StyledFirstTableCell>
                                    <StyledSecondTableCell>{getCentralApprovalStatusDescription(data.statusCode)}</StyledSecondTableCell>
                                </TableRow>
                                {storage.getIsUsePartialRequest() && <TableRow>
                                    <StyledFirstTableCell>{i18next.t("approvalCentral:form.partial")}</StyledFirstTableCell>
                                    <StyledSecondTableCell>{i18next.t(`approvalCentral:table.${dataRequest.isPartial ? "yes" : "no"}`)}</StyledSecondTableCell>
                                </TableRow>}
                                <TableRow>
                                    <StyledFirstTableCell>{i18next.t(`approvalCentral:${dataRequest.isPartial ? "form.request-date" : "form.startDate"}`)}</StyledFirstTableCell>
                                    <StyledSecondTableCell>{formatDate(dataRequest.startDate, 'date')}</StyledSecondTableCell>
                                </TableRow>
                                {!isNullOrEmpty(dataRequest.endDate) && <TableRow>
                                    <StyledFirstTableCell>{i18next.t("approvalCentral:form.endDate")}</StyledFirstTableCell>
                                    <StyledSecondTableCell>{formatDate(dataRequest.endDate, 'date')}</StyledSecondTableCell>
                                </TableRow>}
                                <TableRow>
                                    <StyledFirstTableCell>{i18next.t("approvalCentral:form.approved")}</StyledFirstTableCell>
                                    <StyledSecondTableCell>{i18next.t(`approvalCentral:table.${data.isApproved ? "yes" : "no"}`)}</StyledSecondTableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledFirstTableCell>{i18next.t("approvalCentral:form.hiringDate")}</StyledFirstTableCell>
                                    <StyledSecondTableCell>{formatDate(data.hireDate, 'date')}</StyledSecondTableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledFirstTableCell>{i18next.t("approvalCentral:form.seniorityDate")}</StyledFirstTableCell>
                                    <StyledSecondTableCell>{formatDate(data.seniorityDate, 'date')}</StyledSecondTableCell>
                                </TableRow>
                                {storage.getScheduleReturnDate() && !isNullOrEmpty(dataRequest.returnDate) && <TableRow>
                                    <StyledFirstTableCell>{i18next.t("approvalCentral:form.scheduleReturnDate")}</StyledFirstTableCell>
                                    <StyledSecondTableCell>{formatDate(dataRequest.returnDate, 'date')}</StyledSecondTableCell>
                                </TableRow>}
                                {!isNullOrEmpty(dataRequest.subCodeDescription) && <TableRow>
                                    <StyledFirstTableCell>{i18next.t("approvalCentral:form.leave.payCode")}</StyledFirstTableCell>
                                    <StyledSecondTableCell>{dataRequest.subCodeDescription}</StyledSecondTableCell>
                                </TableRow>}
                                {storage.getIsUsePartialRequest() && dataRequest.isPartial && <TableRow>
                                    <StyledFirstTableCell>{i18next.t("approvalCentral:form.duration")}</StyledFirstTableCell>
                                    <StyledSecondTableCell>{`${parseFloat(dataRequest.duration)} (${dataRequest.durationTypeDescription})`}</StyledSecondTableCell>
                                </TableRow>}
                                {storage.getIsUsePartialRequest() && !isNullOrEmpty(dataRequest.startTime) && <TableRow>
                                    <StyledFirstTableCell>{i18next.t("approvalCentral:form.startTime")}</StyledFirstTableCell>
                                    <StyledSecondTableCell>{dataRequest.startTime}</StyledSecondTableCell>
                                </TableRow>}
                                {storage.getIsUsePartialRequest() && !isNullOrEmpty(dataRequest.endTime) && <TableRow>
                                    <StyledFirstTableCell>{i18next.t("approvalCentral:form.endTime")}</StyledFirstTableCell>
                                    <StyledSecondTableCell>{dataRequest.endTime}</StyledSecondTableCell>
                                </TableRow>}
                                <TableRow>
                                    <StyledFirstTableCell>{i18next.t("approvalCentral:form.approver")}</StyledFirstTableCell>
                                    <StyledSecondTableCell>{data.approverName}</StyledSecondTableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledFirstTableCell>{i18next.t("approvalCentral:form.approval-date")}</StyledFirstTableCell>
                                    <StyledSecondTableCell>{formatDate(data.approvalDate)}</StyledSecondTableCell>
                                </TableRow>
                                {pageSource != pageSourceCode.CALENDAR && !isNullOrEmpty(data.otherClassification) && <TableRow>
                                    <StyledFirstTableCell>{i18next.t("approvalCentral:form.otherClassification")}</StyledFirstTableCell>
                                    <StyledSecondTableCell>{data.otherClassification}</StyledSecondTableCell>
                                </TableRow>}
                                <TableRow>
                                    <StyledCommentTableCell>{i18next.t("approvalCentral:form.comment")}</StyledCommentTableCell>
                                    <StyledSecondTableCell>{dataRequest.employeeComment}</StyledSecondTableCell>
                                </TableRow>
                                {!isEditable && <TableRow>
                                    <StyledCommentTableCell>{i18next.t("approvalCentral:form.approver-comment")}</StyledCommentTableCell>
                                    <StyledSecondTableCell>{dataRequest.approverComment}</StyledSecondTableCell>
                                </TableRow>}
                                <TableRow>
                                    <StyledFirstTableCell>{i18next.t("approvalCentral:form.creation-date")}</StyledFirstTableCell>
                                    <StyledSecondTableCell>{formatDate(data.creationDate)}</StyledSecondTableCell>
                                </TableRow>

                                <TableRow>
                                    <StyledFirstTableCell>{i18next.t("approvalCentral:form.statusToReplace")}</StyledFirstTableCell>
                                    <StyledSecondTableCell>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    disabled={!isToReplaceEnabled}
                                                    checked={isToReplace}
                                                    onChange={onToReplace}
                                                    name="isToReplace"
                                                    variant="success"
                                                />
                                            }
                                            labelPlacement="start"
                                        />
                                    </StyledSecondTableCell>
                                </TableRow>

                                {isEditable && <TableRow>
                                    <StyledCommentTableCell>{i18next.t("approvalCentral:form.approver-comment")}</StyledCommentTableCell>
                                    <StyledSecondTableCell>
                                        <TextField
                                            id="comments"
                                            //label={i18next.t('approvalCentral:form.approver-comment')}
                                            multiline
                                            minRows={4}
                                            className={styles.inputComments}
                                            value={approverComment || ''}
                                            onChange={onChangeComment}
                                        />
                                    </StyledSecondTableCell>
                                </TableRow>}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }

                {showAdditionalInfo &&
                    <div className={classes.divInput} style={{ textAlign: 'center' }} onClick={handleHideAdditionalInfo}>
                        <span style={{ fontSize: '12px', marginRight: '10px' }}>{i18next.t('approvalCentral:button.hideAdditionInformation')}</span>
                        <FontAwesomeIcon icon={faChevronsUp} />
                    </div>
                }

                {dataRequest.isDisplayPayBank &&
                    <LoadingOverlay
                        active={isActive}
                        spinner={<BeatLoader />}
                        text={i18next.t('approvalCentral:form.loading')}
                        className={styles.loadingOverlay}
                    >
                        <div id="divBank" className={styles.rootBankBalance} style={{ marginTop: '5px' }}>
                            <Accordion className={classes.accordionSummary} expanded={expanded === 'panel1'} onChange={handleAccordion('panel1')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon className={classes.iconExpanded} />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <div>{i18next.t("approvalCentral:bank-balance.title")} {dataRequest.payBankCod} - {dataRequest.payBankCodDesc}</div>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <PayBankBalance isFromBankBalanceMenu={false} isLoading={onIsLoadedPayBankBalance} employeeCode={data.employeeCode} payBankCod={dataRequest.payBankCod} />
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    </LoadingOverlay>
                }

                <Box display="flex" justifyContent="space-evenly" marginTop={2} marginBottom={3}>
                    {isActionButtonShown && !dataRequest.isAzur &&
                        !storage.getAllowConsultation() && <LoadingOverlay
                            active={isActive}
                            spinner={<BeatLoader />}
                            text={i18next.t('approvalCentral:form.loading')}
                        >
                            <FormControl fullWidth>
                                <Button
                                    onClick={(event) => handleRequestClick(event, actionType.APPROVE)}
                                    className={`approveButton ${styles.buttonStyle} ${(isPosting || !isApproveButtonEnabled) ? styles.buttonDisabled : ""}`}
                                    style={{ width: "150px" }}
                                    variant="success"
                                >
                                    {i18next.t('approvalCentral:button.approve')}
                                </Button>
                            </FormControl>
                        </LoadingOverlay>
                    }

                    {isActionButtonShown && !dataRequest.isAzur &&
                        !storage.getAllowConsultation() && <LoadingOverlay
                            active={isActive}
                            spinner={<BeatLoader />}
                            text={i18next.t('approvalCentral:form.loading')}
                        >
                            <FormControl fullWidth>
                                <Button
                                    onClick={(event) => handleRequestClick(event, actionType.DENY)}
                                    className={`denyButton ${styles.buttonStyle} ${(isPosting || !isDenyButtonEnabled) ? styles.buttonDisabled : ""}`}
                                    variant="success"
                                >
                                    {denyTitle}
                                </Button>
                            </FormControl>
                        </LoadingOverlay>
                    }

                    {isEditable && !dataRequest.isAzur && <LoadingOverlay
                        active={isActive}
                        spinner={<BeatLoader />}
                        text={i18next.t('approvalCentral:form.loading')}
                    >
                        <FormControl fullWidth>
                            <Button
                                onClick={handleSaveClick}
                                className={`saveButton` + ` ` + styles.buttonStyle}
                                variant="success"
                            >
                                {i18next.t('approvalCentral:button.save')}
                            </Button>
                        </FormControl>
                    </LoadingOverlay>}
                </Box>

            </div>
        </React.Fragment>
    );
}

RequestDetailLeaveDisplay.propTypes = {
    data: PropTypes.object.isRequired,
    dataRequest: PropTypes.object.isRequired
}